import { c as _c } from "react/compiler-runtime";
import { InitShimmer } from '@onefootprint/idv2';
import type { JSX } from 'react';
const Loading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div data-testid="identify-init-shimmer" className="flex flex-col flex-1"><InitShimmer /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Loading;